// extracted by mini-css-extract-plugin
export var box = "_4j-1";
export var checked = "_4j-2";
export var descriptionSpacer = "_4j-9";
export var disabled = "_4j-3";
export var icon = "_4j-6";
export var input = "_4j-0";
export var labelSpacer = "_4j-8";
export var medium = "_4j-5";
export var small = "_4j-4";
export var text = "_4j-7";